export const DAILY_DEPOSIT_LIMIT_AMOUNT = 10_000
export const DAILY_DEPOSIT_LIMIT_TRANSACTIONS = 5
